import { render, staticRenderFns } from "./CertificadoVencido.vue?vue&type=template&id=7295b1a0&"
import script from "./CertificadoVencido.vue?vue&type=script&lang=js&"
export * from "./CertificadoVencido.vue?vue&type=script&lang=js&"
import style0 from "./CertificadoVencido.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports